import api from './index'
import { axios } from '@/utils/request'

//  系统管理员（即平台管理员）管理整个的系统平台的用户角色信息，包括对用户角色的新建、修改、删除
//  和查找整个的用户角色的列表，还包括对用户角色的权限显示和用户权限的授权过程

//  以下为获取整个用户角色的列表
export function getRoleList (parameter) {
  return axios({
    url: api.GetRoleList,
    method: 'get',
    params: parameter
  })
}

//  以下为更新整个某一个用户角色的信息的列表
export function updateRole (parameter) {
  return axios({
    url: api.UpdateRole,
    method: 'put',
    params: parameter
  })
}

// 以下为创建一个新的用户角色的列表
export function createRole (params) {
  return axios({
    url: api.CreateRole,
    method: 'post',
    params: params
  })
}

// 以下为删除某一个用户用户角色的方法，只需要传输一个userUid即可
export function deleteRole (id) {
  return axios({
    url: api.DeleteRole + '/' + id,
    method: 'delete'
  })
}

//  以下为获取某一个用户角色权限的列表的方法
export function getRolePer (parameter) {
  return axios({
    url: api.GetRolePermission,
    method: 'get',
    params: parameter
  })
}

//  以下为给某一个用户角色进行授权的方法
export function grantRolePer (parameter) {
  return axios({
    url: api.GrantPermission,
    method: 'post',
    params: parameter
  })
}

